import NotFound from "../../components/NotFound";

const _NotFound = () => {
    return (
        <>
            <NotFound/>
        </>
    )
}

export default _NotFound;